import styled from 'styled-components'

const TextTab = styled.div`
  
`

export {TextTab}
